import { useEffect, useState, useCallback } from "react";
import { DeviceUtils } from "../utils/deviceUtils.js";
import { useSelector } from "react-redux";
import {
  CasinoSelectors,
  UserContextSelectors
} from "../redux/selectors/index.js";
import { useFeature } from "./useFeature.js";
import { AppFeatures } from "../constants/featureFlags.js";
import { PageContextUtils } from "../utils/index.js";

export const useBottomBar = () => {
  const [isDisplayedButtonBar, setIsDisplayedButtonBar] = useState(false);
  const isBottomNavigationFeatureEnabled = useFeature(
    AppFeatures.MOBILE_WEB_BOTTOM_NAVBAR
  );

  const { bottomBarNavigationComponents } = PageContextUtils.getVisualData();
  const isBottomNavigationEnabled =
    isBottomNavigationFeatureEnabled && !!bottomBarNavigationComponents;
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const isNative = useSelector(UserContextSelectors.isNative);
  const isSIC = useSelector(CasinoSelectors.isSIC);
  const isSIP = DeviceUtils.isPokerApp();

  const evaluateFlags = useCallback(() => {
    const _generalConditions =
      isBottomNavigationEnabled && isMobile && !isNative && !isSIC && !isSIP;

    setIsDisplayedButtonBar(_generalConditions);
  }, [isBottomNavigationEnabled, isMobile, isNative, isSIC, isSIP]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      evaluateFlags();
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [evaluateFlags]);

  return {
    isDisplayedButtonBar
  };
};
